import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { cleverThemeModule } from './modules/theme';
import { signInPageModule } from './modules/signin';

export default createApp({
  features: [catalogPlugin, navModule, cleverThemeModule, signInPageModule],
});
